import { render, staticRenderFns } from "./AnnotoriousRenderer.vue?vue&type=template&id=ded505f4&scoped=true"
import script from "./AnnotoriousRenderer.vue?vue&type=script&lang=js"
export * from "./AnnotoriousRenderer.vue?vue&type=script&lang=js"
import style0 from "./AnnotoriousRenderer.vue?vue&type=style&index=0&id=ded505f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded505f4",
  null
  
)

export default component.exports